
<ng-container *ngIf="userPermissions.indexOf('create') >= 0">
  <div class="table-title">
    <div class="title-form-wrapper big">
      <a [routerLink]="['/dashboard/new-role']" type="submit" class="btn btn-primary big">
        <img src="../../../assets/qh-suite/icons/add.svg" alt="icon">
        Nuevo rol
      </a>
      <!-- <a [routerLink]="['/dashboard/smart-search']" type="submit" class="btn btn-outline-primary big">
        <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.6063 13.1125L7.91876 8.425C7.54376 8.7375 7.11251 8.98125 6.62501 9.15625C6.13751 9.33125 5.65001 9.41875 5.16251 9.41875C3.95001 9.41875 2.92826 9.003 2.09726 8.1715C1.26576 7.3405 0.850006 6.325 0.850006 5.125C0.850006 3.925 1.26576 2.90925 2.09726 2.07775C2.92826 1.24675 3.94376 0.831253 5.14376 0.831253C6.34376 0.831253 7.36251 1.24675 8.20001 2.07775C9.03751 2.90925 9.45626 3.925 9.45626 5.125C9.45626 5.65 9.36251 6.15625 9.17501 6.64375C8.98751 7.13125 8.74376 7.54375 8.44376 7.88125L13.15 12.5875L12.6063 13.1125ZM5.16251 8.66875C6.15001 8.66875 6.98751 8.32825 7.67501 7.64725C8.36251 6.96575 8.70626 6.125 8.70626 5.125C8.70626 4.125 8.36251 3.28425 7.67501 2.60275C6.98751 1.92175 6.15001 1.58125 5.16251 1.58125C4.16251 1.58125 3.31876 1.92175 2.63126 2.60275C1.94376 3.28425 1.60001 4.125 1.60001 5.125C1.60001 6.125 1.94376 6.96575 2.63126 7.64725C3.31876 8.32825 4.16251 8.66875 5.16251 8.66875Z" fill="#279CB1"/>
        </svg>
        Búsqueda Cliente
      </a> -->
      <!-- <button type="submit" class="btn btn-second big">
        <img src="../../../assets/qh-suite/icons/check.svg" alt="icon">
        Aprobaciones
      </button> -->
    </div>
  </div>

  <hr>
</ng-container>

<div class="table-title-wrapper mb-5">
  <!-- <h3 class="mb-5">Filtros</h3> -->
  <div class="table-title" [formGroup]="filtersForm">
    &nbsp;
    <!-- <div class="title-form-wrapper big-2">
      <div class="form-group">
        <span>Fecha Inicio:</span>
        <input type="date" class="form-control" formControlName="start_date">
      </div>
      <div class="form-group">
        <span>Rol:</span>
        <mat-select formControlName="role" placeholder="Seleccione una opción">
          <ng-container *ngIf="roles; else elseRoles">
            <div class="filter_option">
              <input placeholder="Buscar..." [(ngModel)]="filterTerm" class="!outline-none" [ngModelOptions]="{standalone: true}">
            </div>
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let role of roles | filter: filterTerm; let i = index" [value]="role.name">{{ role.name | titlecase }}</mat-option>
          </ng-container>
          <ng-template #elseRoles>
            <mat-option value="">No se encontraron resultados...</mat-option>
          </ng-template>
        </mat-select>
      </div>
      <div class="form-group">
        <span>Estado:</span>
        <mat-select formControlName="status" placeholder="Seleccione una opción">
          <ng-container *ngIf="status; else elseStatus">
            <div class="filter_option">
              <input placeholder="Buscar..." [(ngModel)]="filterTerm2" class="!outline-none" [ngModelOptions]="{standalone: true}">
            </div>
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let itemStatus of status | filter: filterTerm2; let i = index" [value]="itemStatus.value">{{ itemStatus.name }}</mat-option>
          </ng-container>
          <ng-template #elseStatus>
            <mat-option value="">No se encontraron resultados...</mat-option>
          </ng-template>
        </mat-select>
      </div>
      <button type="submit" class="btn btn-primary" (click)="getRoles()">
        <img src="../../../assets/qh-suite/icons/search.svg" alt="icon">
        Buscar
      </button>
    </div> -->

    <div class="title-btn-wrapper type-2">
      <!-- <button type="submit" class="btn btn-accent">
        <img src="../../../assets/qh-suite/icons/picture_as_pdf.svg" alt="icon">
        PDF
      </button> -->
      <a type="button" class="btn btn-second" (click)="getExcel()" *ngIf="userPermissions.indexOf('reports') >= 0">
        <img src="../../../assets/qh-suite/icons/contact_page.svg" alt="icon">
        Excel
      </a>
    </div>
  </div>
</div>

<app-custom-table [displayedColumns]="displayedColumns" [data]="dataSource" [tableTitle]="'Últimos roles agregados'"></app-custom-table>
